<template>
    <div id="addendumPrint">
        <h1>Документ A</h1>
        <p>Содержимое документа A</p>
    </div>
</template>